import React from 'react';

/**
 * Renderiza el bloque TemperatureChart de SCAPP V2.
 *
 * @param {object} props
 * @param {object} props.v - Modelo de presentación y callbacks del panel.
 * @returns {React.ReactNode} Bloque visual sin estado local.
 */
export default function TemperatureChart({
  v
}) {
  return React.createElement("div", {
    className: "scapp-detail-chart-row",
    style: {
      "display": v.showCurrent ? "grid" : "none",
      "gridTemplateColumns": "13.541667vw 2.291667vw minmax(0,1fr) 4.791667vw",
      "gap": "0",
      "alignItems": "center"
    }
  }, React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.092593vh",
      "paddingRight": "0.208333vw"
    }
  }, React.createElement("button", {
    type: "button",
    "data-detail-legend": "current",
    "aria-pressed": v.showCurrentSeries,
    onClick: () => v.toggleDetailMetric("current"),
    style: {
      "display": v.hasCurrent ? "grid" : "none",
      "border": "0",
      "background": "transparent",
      "padding": "0",
      "width": "100%",
      "textAlign": "left",
      "cursor": "pointer",
      "opacity": v.showCurrentSeries ? "1" : "0.38",
      "gridTemplateColumns": "0.625vw minmax(0,1fr) auto",
      "gap": "0.740741vh",
      "alignItems": "center",
      "fontSize": "1.203704vh",
      "lineHeight": "1.851852vh"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.625vw",
      "height": "0.277778vh",
      "borderRadius": "0.185185vh",
      "background": "oklch(0.72 0.14 295)"
    }
  }, null), React.createElement("span", {
    style: {
      "color": "#b8c1ce",
      "whiteSpace": "nowrap",
      "overflow": "hidden",
      "textOverflow": "ellipsis"
    }
  }, v.text("Corriente [cm/s]")), React.createElement("span", {
    style: {
      "font": "600 1.296296vh 'IBM Plex Mono',monospace",
      "color": "oklch(0.72 0.14 295)",
      "opacity": v.vOp,
      "whiteSpace": "nowrap"
    }
  }, v.text(v.vC))), React.createElement("button", {
    type: "button",
    "data-detail-legend": "direction",
    "aria-pressed": v.showDirectionSeries,
    onClick: () => v.toggleDetailMetric("direction"),
    style: {
      "display": v.hasDirection ? "grid" : "none",
      "border": "0",
      "background": "transparent",
      "padding": "0",
      "width": "100%",
      "textAlign": "left",
      "cursor": "pointer",
      "opacity": v.showDirectionSeries ? "1" : "0.38",
      "gridTemplateColumns": "0.625vw minmax(0,1fr) auto",
      "gap": "0.740741vh",
      "alignItems": "center",
      "fontSize": "1.203704vh",
      "lineHeight": "1.851852vh"
    }
  }, React.createElement("span", {
    style: {
      "justifySelf": "center",
      "color": "oklch(0.72 0.14 295)",
      "fontWeight": "700",
      "fontSize": "1.111111vh",
      "lineHeight": "1",
      "transform": "rotate(" + v.vCdRot + "deg)"
    }
  }, v.text("↑")), React.createElement("span", {
    style: {
      "color": "#b8c1ce"
    }
  }, v.text("Dirección")), React.createElement("span", {
    style: {
      "font": "600 1.296296vh 'IBM Plex Mono',monospace",
      "color": "oklch(0.72 0.14 295)",
      "opacity": v.vOp
    }
  }, v.text(v.vCd)))), React.createElement("div", {
    "onMouseMove": v.hMove,
    "onMouseLeave": v.hLeave,
    "onMouseDown": v.hDown,
    "onMouseUp": v.hUp,
    "onWheel": v.hWheel,
    "data-wheel-zoom": "1",
    style: {
      "gridColumn": "3",
      "position": "relative",
      "display": "flex",
      "flexDirection": "column",
      "cursor": v.hCursor,
      "userSelect": "none"
    }
  }, React.createElement("div", {
    style: {
      "position": "absolute",
      "left": "0",
      "right": "0",
      "top": v.showDirectionSeries ? "1.851852vh" : "0",
      "bottom": "0",
      "pointerEvents": "none",
      "display": v.showCurrentSeries ? "block" : "none"
    }
  }, (v.det.axC || []).map((t, index26) => React.createElement(React.Fragment, {
    key: index26
  }, React.createElement("div", {
    style: {
      "position": "absolute",
      "left": "0",
      "right": "0",
      "top": t.top,
      "borderTop": "0.092593vh solid rgba(135,147,166,0.13)"
    }
  }, null)))), React.createElement("div", {
    style: {
      "position": "absolute",
      "left": "-2.291667vw",
      "width": "2.291667vw",
      "top": v.showDirectionSeries ? "1.851852vh" : "0",
      "bottom": "0",
      "pointerEvents": "none",
      "display": v.showCurrentSeries ? "block" : "none",
      "borderRight": "0.052083vw solid oklch(0.72 0.14 295 / 0.55)"
    }
  }, (v.det.axC || []).map((t, index27) => React.createElement(React.Fragment, {
    key: index27
  }, React.createElement("span", {
    style: {
      "position": "absolute",
      "right": "0",
      "top": t.top,
      "width": "0.208333vw",
      "borderTop": "0.092593vh solid oklch(0.72 0.14 295)"
    }
  }, null), React.createElement("span", {
    style: {
      "position": "absolute",
      "right": "0.364583vw",
      "top": t.lt,
      "transform": "translateY(-50%)",
      "font": "0.925926vh 'IBM Plex Mono',monospace",
      "whiteSpace": "nowrap",
      "color": "oklch(0.72 0.14 295)"
    }
  }, v.text(t.lab))))), React.createElement("div", {
    style: {
      "position": "relative",
      "display": v.showDirectionSeries ? "block" : "none",
      "height": "1.851852vh",
      "background": "rgba(4,12,24,0.55)",
      "borderRadius": "0.37037vh 0.37037vh 0 0"
    }
  }, v.text("\n                  "), (v.zArrows || []).map((a, index28) => React.createElement(React.Fragment, {
    key: index28
  }, v.text("\n                    "), React.createElement("div", {
    style: {
      "position": "absolute",
      "top": "50%",
      "left": a.left,
      "lineHeight": "1",
      "color": "oklch(0.72 0.14 295)",
      "fontWeight": "600",
      "fontSize": a.size / 10.8 + "vh",
      "opacity": a.op,
      "transform": "translate(-50%,-50%) rotate(" + a.rot + "deg)"
    }
  }, v.text("↑")), v.text("\n                  "))), v.text("\n                ")), React.createElement("svg", {
    "viewBox": v.zVB,
    "preserveAspectRatio": "none",
    style: {
      "width": "100%",
      "height": v.dH.c / 10.8 + "vh",
      "display": "block",
      "background": "rgba(4,12,24,0.55)",
      "borderRadius": "0.37037vh"
    }
  }, React.createElement("path", {
    "d": v.czSpan,
    "fill": "oklch(0.66 0.19 42 / 0.16)",
    "stroke": "none"
  }, null), React.createElement("path", {
    "d": v.det.curArea,
    "display": v.showCurrentSeries ? "inline" : "none",
    "fill": "oklch(0.72 0.14 295 / 0.18)",
    "stroke": "none"
  }, null), React.createElement("path", {
    "d": v.thrPath,
    "display": v.showCurrentSeries ? "inline" : "none",
    "stroke": "oklch(0.66 0.19 25)",
    "strokeWidth": "1",
    "fill": "none",
    "vectorEffect": "non-scaling-stroke",
    "strokeDasharray": "6 4",
    "opacity": "0.7"
  }, null), React.createElement("path", {
    "d": v.det.cur,
    "display": v.showCurrentSeries ? "inline" : "none",
    "stroke": "oklch(0.72 0.14 295)",
    "strokeWidth": "2",
    "fill": "none",
    "vectorEffect": "non-scaling-stroke"
  }, null)), React.createElement("div", {
    style: {
      "position": "absolute",
      "top": "0",
      "bottom": "0",
      "left": v.hx,
      "width": "0.052083vw",
      "background": "#e4e9f0",
      "opacity": "0.55",
      "pointerEvents": "none",
      "display": v.hDisp
    }
  }, null), React.createElement("div", {
    style: {
      "position": "absolute",
      "top": "0",
      "bottom": "0",
      "left": v.selL,
      "width": v.selW,
      "background": "rgba(228,233,240,0.12)",
      "borderLeft": "0.052083vw solid #8793a6",
      "borderRight": "0.052083vw solid #8793a6",
      "pointerEvents": "none",
      "display": v.selD
    }
  }, null)));
}
